var _path, _path2, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileIconRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.537476V10.3375C14 11.4514 14.4425 12.5197 15.2302 13.3073C16.0178 14.095 17.0861 14.5375 18.2 14.5375H28V29.1375C28 30.2514 27.5575 31.3197 26.7698 32.1073C25.9822 32.895 24.9139 33.3375 23.8 33.3375H14H4.2C3.08609 33.3375 2.0178 32.895 1.23015 32.1073C0.442499 31.3197 0 30.2514 0 29.1375V4.73748C0 3.62357 0.442499 2.55528 1.23015 1.76763C2.0178 0.979975 3.08609 0.537476 4.2 0.537476H14Z",
    fill: "#6C42C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 10.3375V1.23755L27.3 11.7375H18.2C17.8287 11.7375 17.4726 11.59 17.21 11.3275C16.9475 11.0649 16.8 10.7089 16.8 10.3375Z",
    fill: "#EF4F5F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.22852,
    y: 19.6803,
    width: 16.4571,
    height: 2.74286,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.22852,
    y: 25.166,
    width: 16.4571,
    height: 2.74286,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconRed);
export default __webpack_public_path__ + "static/media/file-icon-red.ce85e4f9cd11df451846dfb05710d1f8.svg";
export { ForwardRef as ReactComponent };